import React from 'react'
import { NavigationFooter } from '@brainstud/react-tbl/features/navigation'

const Footer = props => (
  <NavigationFooter
    title={`${props.chapter.prefix}.${props.lesson.prefix} ${props.lesson.title}`}
    items={props.chapter.lessons}
    active={props.lesson.id}
    homeButton
    mapButton={props.lesson.options.map}
    mapButtonLayers={props.lesson.options.map}
    prevButton
    prevLabel="Vorige"
    prevTo={props.prevButtonTo}
    nextButton
    nextLabel="Volgende"
    nextTo={props.nextButtonTo} />
)

export default Footer
